(() => {
  // Remove single-item filters from collections pages
  function removeSingleItemFilters() {
    const body = document.querySelector("body");
    if (!body.classList.contains("template-collection")) {
      return;
    }

    const jsFilters = body.querySelectorAll("details.js-filter");

    for (const jsFilter of jsFilters) {
      const facetCount = jsFilter.querySelectorAll(".facets__item").length;

      if (facetCount <= 1) {
        jsFilter.remove();
      }
    }
  }

  removeSingleItemFilters();
})();
